import { gql } from "apollo-boost";

export const GET_ACADEMICPERIOD = gql`
  query getAcademicPeriod($id: ID!) {
    getAcademicPeriod(
      id: $id
    ) {
      id
      periodCode
      year
      semester

      learnSpan1StartDate
      learnSpan1EndDate
      learnSpan2StartDate
      learnSpan2EndDate
      useLearnSpanOnline
      useLearnSpanNormal
    }
  }
`;

export const GET_ACADEMICPERIODS = gql`
  query getAcademicPeriods {
    getAcademicPeriods {
      id
      periodCode
      year
      semester
      isDisabled
      label: periodCode

      learnSpan1StartDate
      learnSpan1EndDate
      learnSpan2StartDate
      learnSpan2EndDate
      useLearnSpanOnline
      useLearnSpanNormal
    }
  }
`;

export const ADD_ACADEMICPERIOD = gql`
  mutation addAcademicPeriod(
    $periodCode: String!,
    $year: String!,
    $semester: Int!,
    $learnSpan1StartDate: String,
    $learnSpan1EndDate: String,
    $learnSpan2StartDate: String,
    $learnSpan2EndDate: String,
    $useLearnSpanOnline:  Boolean,
    $useLearnSpanNormal:  Boolean
  ) {
    addAcademicPeriod (
      periodCode: $periodCode,
      year: $year,
      semester: $semester,
      learnSpan1StartDate: $learnSpan1StartDate,
      learnSpan1EndDate: $learnSpan1EndDate,
      learnSpan2StartDate: $learnSpan2StartDate,
      learnSpan2EndDate: $learnSpan2EndDate
      useLearnSpanOnline: $useLearnSpanOnline
      useLearnSpanNormal: $useLearnSpanNormal
    ) {
      id
      periodCode
      year
      semester

      learnSpan1StartDate
      learnSpan1EndDate
      learnSpan2StartDate
      learnSpan2EndDate
      useLearnSpanOnline
      useLearnSpanNormal
    }
  }
`;

export const UPDATE_ACADEMICPERIOD = gql`
  mutation updateAcademicPeriod(
    $id: ID!,
    $periodCode: String!,
    $year: String!,
    $semester: Int!,
    $learnSpan1StartDate: String,
    $learnSpan1EndDate: String,
    $learnSpan2StartDate: String,
    $learnSpan2EndDate: String,
    $useLearnSpanOnline:  Boolean,
    $useLearnSpanNormal:  Boolean
  ) {
    updateAcademicPeriod (
      id: $id,
      periodCode: $periodCode,
      year: $year,
      semester: $semester,
      learnSpan1StartDate: $learnSpan1StartDate,
      learnSpan1EndDate: $learnSpan1EndDate,
      learnSpan2StartDate: $learnSpan2StartDate,
      learnSpan2EndDate: $learnSpan2EndDate
      useLearnSpanOnline: $useLearnSpanOnline
      useLearnSpanNormal: $useLearnSpanNormal
    ) {
      id
      periodCode
      year
      semester

      learnSpan1StartDate
      learnSpan1EndDate
      learnSpan2StartDate
      learnSpan2EndDate
      useLearnSpanOnline
      useLearnSpanNormal
    }
  }
`;

export const DELETE_ACADEMICPERIOD = gql`
  mutation deleteAcademicPeriod(
    $id: ID!
  ) {
    deleteAcademicPeriod (
      id: $id
    ) {
      id
      periodCode
      year
      semester

      learnSpan1StartDate
      learnSpan1EndDate
      learnSpan2StartDate
      learnSpan2EndDate
      useLearnSpanOnline
      useLearnSpanNormal
    }
  }
`;


/* TYPES

type AcademicPeriod {
  id: ID!
  periodCode: String!
  year: String!
  semester: Int!
  isDisabled: Boolean!
  createdAt: String!
  updatedAt: String!
  createdBy: User
  updatedBy: User
}

*/
